import closeOuter from './lib/CloseOuter';

const searchbarInit = (header: HTMLElement) => {
  const buttons = header.querySelectorAll('.header__search');
  const bar = header.querySelector('.header__searchbar');
  const input = header.querySelector('.searchform__search') as HTMLElement | null;
  const outerClick = (event: Event) => {
    const clicked = event.target as HTMLElement;
    const check = closeOuter(clicked, 'header__searchbar');
    if (check) {
      document.removeEventListener('click', outerClick);
      bar?.classList.remove('header__searchbar--active');
      document.removeEventListener('click', outerClick);
    }
  };

  const close = (e) => {
    if (e.key === 'Escape') {
      bar?.classList.remove('header__searchbar--active');
      document.removeEventListener('click', outerClick);
    }
  };
  document.addEventListener('keydown', close);
  if (buttons.length > 0) {
    [...buttons].forEach((button: HTMLElement) => {
      button.addEventListener('click', () => {
        bar?.classList.toggle('header__searchbar--active');
        if (input != null) {
          input.focus();
        }

        if (bar.classList.contains('header__searchbar--active')) {
          setTimeout(() => {
            document.addEventListener('click', outerClick);
          }, 100);
        } else {
          document.removeEventListener('click', outerClick);
        }
      });
    });
  }
};

export default searchbarInit;
